import { render, staticRenderFns } from "./TrademarkPublicationTypeForm.vue?vue&type=template&id=57c48e3e&"
import script from "./TrademarkPublicationTypeForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkPublicationTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkPublicationTypeForm.vue?vue&type=style&index=0&id=57c48e3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports